"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionIcon = exports.OptionLabel = exports.EmptyOptionsElement = exports.OptionItemDescription = exports.AssistiveText = exports.OptionItem = exports.OptionsList = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.OptionsList = theme_1.styled.ul `
  ${(props) => props.theme.common['box-shadow']};
  width: 100%;
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : theme.common.radius; }};
  background: ${({ theme }) => theme.colors.neutral[0]};
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 12px 0;
  max-height: ${({ hasAssistiveText }) => hasAssistiveText ? '222px' : '208px'};
  overflow: auto;
`;
exports.OptionItem = theme_1.styled.li `
  ${theme_1.mixins.flex({
    justifyContent: 'space-between',
    verticalAlignment: 'center',
})}
  ${theme_1.typography.regular18};
  width: 100%;
  min-height: 48px;
  color: ${({ selected, isMultiSelect, theme }) => selected && !isMultiSelect
    ? theme.colors.text.interactive
    : theme.colors.text.primary};
  box-sizing: border-box;
  padding: 0 16px;
  transition: background-color 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[10]};
  }
`;
exports.AssistiveText = theme_1.styled.div `
  ${theme_1.typography.regular14};
  color: ${({ theme }) => theme.colors.text.secondary};
  box-sizing: border-box;
  padding: 0 16px;
`;
exports.OptionItemDescription = theme_1.styled.div `
  ${theme_1.typography.regular14};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
exports.EmptyOptionsElement = theme_1.styled.div `
  ${theme_1.typography.regular18};
  ${theme_1.mixins.flex({
    verticalAlignment: 'center',
    justifyContent: 'space-between',
})};
  padding: 0 16px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.secondary};
  width: 100%;
`;
exports.OptionLabel = theme_1.styled.div `
  max-width: calc(100% - 38px);
`;
exports.OptionIcon = theme_1.styled.div `
  ${theme_1.mixins.flex({})};
`;
